//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import pluginExport from '@d2-projects/vue-table-export';
Vue.use(pluginExport);
export default {
  data: function data() {
    return {
      text: ''
    };
  },
  methods: {
    exportTxt: function exportTxt() {
      var _this = this;

      // 校验是不是空
      if (this.text === '') {
        this.$message('虽然可以为空 但是出于体验不建议这样 还是写点东西吧');
        return;
      } // 导出


      this.$export.txt({
        text: this.text,
        title: '文本'
      }).then(function () {
        _this.$message('导出文本成功');
      });
    }
  }
};